//
// Options to be provided to Valstream video player constructor.
function ValstreamVideoPlayerOptions(){

    this.elementId                                    = null;
    this.playlistVideoUrls                            = null; // TODO: Might be provided with files that are not only MP4, should provide the media type with the link.
    this.maxAdErrorRetries                            = null;
    this.maxPrerollAdCount                            = null;
    this.autoNavTimeInMillisecondsNextVideoPrompt     = null;
    this.autoNavTimeInMillisecondsNextVideoTransition = null;
    this.prerollTimeoutInMilliseconds                 = null;
    this.allowSkipCountdownPause                      = null;
    this.biddingManager                               = null;
    this.logger                                       = null;
    this.eventHelper                                  = null;
    this.googleAnalytics                              = null;
    this.videoJsLibrary                               = null;
    this.googleLibrary                                = null;
    this.modeLayout                                   = null;
    this.allowAutoplay                                = null;
    this.allowAds                                     = null;
    this.showTitle                                    = null;
    this.showClickThroughButton                       = null;
    this.changingVideoDetails                         = null;
    this.showOverlays                                 = null;
    this.allowAutoplayWhenInView                      = null;
    this.allowAutoPlaylistNavigation                  = null;
    this.delayAfterAdSkippedInMilliseconds            = null;
    this.delayAfterAdClosedInMilliseconds             = null;
    this.useLargeSoundToggleButton                    = null;
    this.soundOn                                      = null;
    this.videoType                                    = null;
    this.requestDelayNoAdFillInMilliseconds           = null;
    this.requestDelayAdErrorInMilliseconds            = null;
    this.adSchedule                                   = null;
    this.autoplay                                     = null;
    this.forceAdSkip                                  = null; 
    this.forceAdSkipTimeoutInSeconds                  = null; 
    this.renderAdWithReponseOverTag                   = null;
    this.aspectRatio                                  = null;
    this.externalFloatControl                         = null;

    //
    // elementId
    this.get_elementId = function(){

        return this.elementId;
    };
    this.set_elementId = function(value){

        this.elementId = value;
    };

    //
    // playlistVideoUrls
    this.get_playlistVideoUrls = function(){

        return this.playlistVideoUrls;
    };
    this.set_playlistVideoUrls = function(value){

        this.playlistVideoUrls = value;
    };

    //
    // playlistVideoUrls
    this.get_playlist = function(){

        return this.playlist;
    };
    this.set_playlist = function(value){

        this.playlist = value;
    };

    //
    // maxAdErrorRetries
    this.get_maxAdErrorRetries = function(){

        return this.maxAdErrorRetries;
    };
    this.set_maxAdErrorRetries = function(value){

        this.maxAdErrorRetries = value;
    };

    //
    // maxPrerollAdCount
    this.get_maxPrerollAdCount = function(){

        return this.maxPrerollAdCount;
    };
    this.set_maxPrerollAdCount = function(value){

        this.maxPrerollAdCount = value;
    };

    //
    // autoNavTimeInMillisecondsNextVideoPrompt
    this.get_autoNavTimeInMillisecondsNextVideoPrompt = function(){

        return this.autoNavTimeInMillisecondsNextVideoPrompt;
    };
    this.set_autoNavTimeInMillisecondsNextVideoPrompt = function(value){

        this.autoNavTimeInMillisecondsNextVideoPrompt = value;
    };

    //
    // autoNavTimeInMillisecondsNextVideoTransition
    this.get_autoNavTimeInMillisecondsNextVideoTransition = function(){

        return this.autoNavTimeInMillisecondsNextVideoTransition;
    };
    this.set_autoNavTimeInMillisecondsNextVideoTransition = function(value){

        this.autoNavTimeInMillisecondsNextVideoTransition = value;
    };

    //
    // prerollTimeoutInMilliseconds
    this.get_prerollTimeoutInMilliseconds = function(){

        return this.prerollTimeoutInMilliseconds;
    };
    this.set_prerollTimeoutInMilliseconds = function(value){

        this.prerollTimeoutInMilliseconds = value;
    };

    //
    // allowSkipCountdownPause
    this.get_allowSkipCountdownPause = function(){

        return this.allowSkipCountdownPause;
    };
    this.set_allowSkipCountdownPause = function(value){

        this.allowSkipCountdownPause = value;
    };

    //
    // biddingManager
    this.get_biddingManager = function(){

        return this.biddingManager;
    };
    this.set_biddingManager = function(value){

        this.biddingManager = value;
    };

    //
    // logger
    this.get_logger = function(){

        return this.logger;
    };
    this.set_logger = function(value){

        this.logger = value;
    };

    //
    // eventHelper
    this.get_eventHelper = function(){

        return this.eventHelper;
    };
    this.set_eventHelper = function(value){

        this.eventHelper = value;
    };

    //
    // googleAnalytics
    this.get_googleAnalytics = function(){

        return this.googleAnalytics;
    };
    this.set_googleAnalytics = function(value){

        this.googleAnalytics = value;
    };

    //
    // videoJsLibrary
    this.get_videoJsLibrary = function(){

        return this.videoJsLibrary;
    };
    this.set_videoJsLibrary = function(value){

        this.videoJsLibrary = value;
    };

    //
    // googleLibrary
    this.get_googleLibrary = function(){

        return this.googleLibrary;
    };
    this.set_googleLibrary = function(value){

        this.googleLibrary = value;
    };

    //
    // modeLayout
    this.get_modeLayout = function(){

        return this.modeLayout;
    };
    this.set_modeLayout = function(value){

        this.modeLayout = value;
    };

    //
    // allowAutoplay
    this.get_allowAutoplay = function(){

        return this.allowAutoplay;
    };
    this.set_allowAutoplay = function(value){

        this.allowAutoplay = value;
    };

    //
    // allowAds
    this.get_allowAds = function(){

        return this.allowAds;
    };
    this.set_allowAds = function(value){

        this.allowAds = value;
    };

    //
    // showTitle
    this.get_showTitle = function(){

        return this.showTitle;
    };
    this.set_showTitle = function(value){

        this.showTitle = value;
    };

    //
    // showClickThroughButton
    this.get_showClickThroughButton = function(){
        
        return this.showClickThroughButton;
    };
    this.set_showClickThroughButton = function(value){
        
        this.showClickThroughButton = value;
    };

    //
    // changingVideoDetails
    this.get_changingVideoDetails = function(){

        return this.changingVideoDetails;
    };
    this.set_changingVideoDetails = function(value){

        this.changingVideoDetails = value;
    };

    //
    // showOverlays
    this.get_showOverlays = function(){

        return this.showOverlays;
    };
    this.set_showOverlays = function(value){

        this.showOverlays = value;
    };

    //
    // allowAutoplayWhenInView
    this.get_allowAutoplayWhenInView = function(){

        return this.allowAutoplayWhenInView;
    };
    this.set_allowAutoplayWhenInView = function(value){

        this.allowAutoplayWhenInView = value;
    };

    //
    // allowAutoPlaylistNavigation
    this.get_allowAutoPlaylistNavigation = function(){

        return this.allowAutoPlaylistNavigation;
    };
    this.set_allowAutoPlaylistNavigation = function(value){

        this.allowAutoPlaylistNavigation = value;
    };

    //
    // delayAfterAdSkippedInMilliseconds
    this.get_delayAfterAdSkippedInMilliseconds = function(){

        return this.delayAfterAdSkippedInMilliseconds;
    };
    this.set_delayAfterAdSkippedInMilliseconds = function(value){

        this.delayAfterAdSkippedInMilliseconds = value;
    };

    //
    // delayAfterAdClosedInMilliseconds
    this.get_delayAfterAdClosedInMilliseconds = function(){

        return this.delayAfterAdClosedInMilliseconds;
    };
    this.set_delayAfterAdClosedInMilliseconds = function(value){

        this.delayAfterAdClosedInMilliseconds = value;
    };

    //
    // useLargeSoundToggleButton
    this.get_useLargeSoundToggleButton = function(){
        
        return this.useLargeSoundToggleButton;
    }
    this.set_useLargeSoundToggleButton = function(value){
        
        this.useLargeSoundToggleButton = value;
    }

    //
    // soundOn
    this.get_soundOn = function(){
        
        return this.soundOn;
    }
    this.set_soundOn = function(value){
     
        this.soundOn = value;
    }

    //
    // videoType
    this.get_videoType = function(){
        
        return this.videoType;
    }
    this.set_videoType = function(value){
     
        this.videoType = value;
    }

    //
    // requestDelayNoAdFillInMilliseconds
    this.get_requestDelayNoAdFillInMilliseconds = function(){
        
        return this.requestDelayNoAdFillInMilliseconds;
    }
    this.set_requestDelayNoAdFillInMilliseconds = function(value){
        
        this.requestDelayNoAdFillInMilliseconds = value;
    }

    //
    // requestDelayAdErrorInMilliseconds
    this.get_requestDelayAdErrorInMilliseconds = function(){
        
        return this.requestDelayAdErrorInMilliseconds;
    }
    this.set_requestDelayAdErrorInMilliseconds = function(value){
        
        this.requestDelayAdErrorInMilliseconds = value;
    }

    //
    // adSchedule
    this.get_adSchedule = function(){
        
        return this.adSchedule;
    }
    this.set_adSchedule = function(value){
        
        this.adSchedule = value;
    }

    //
    // autoplay
    this.get_autoplay = function(){
        
        return this.autoplay;
    }
    this.set_autoplay = function(value){
        
        this.autoplay = value;
    }

    //
    // forceAdSkip
    this.get_forceAdSkip = function(){
        
        return this.forceAdSkip;
    }
    this.set_forceAdSkip = function(value){
        
        this.forceAdSkip = value;
    }

    //
    // forceAdSkipTimeoutInSeconds
    this.get_forceAdSkipTimeoutInSeconds = function(){
        
        return this.forceAdSkipTimeoutInSeconds;
    }
    this.set_forceAdSkipTimeoutInSeconds = function(value){
        
        this.forceAdSkipTimeoutInSeconds = value;
    }

    //
    // renderAdWithReponseOverTag
    this.get_renderAdWithReponseOverTag = function(){
        
        return this.renderAdWithReponseOverTag;
    }
    this.set_renderAdWithReponseOverTag = function(value){
        
        this.renderAdWithReponseOverTag = value;
    }    
    
    //
    // aspectRatio
    this.get_aspectRatio = function(){
        
        return this.aspectRatio;
    }
    this.set_aspectRatio = function(value){
        
        this.aspectRatio = value;
    }

    //
    // externalFloatControl
    this.get_externalFloatControl = function(){
        
        return this.externalFloatControl;
    }
    this.set_externalFloatControl = function(value){
        
        this.externalFloatControl = value;
    }
}

window.ValstreamVideoPlayerOptions = ValstreamVideoPlayerOptions;